import { Routes, Route, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { Toaster } from '@/components/ui/toaster'
import { useToast } from '@/hooks/use-toast'
import { tokenManager } from '@/utils'
import Home from './pages/Home'
import Dashboard from './pages/Dashboard'
import Settings from './pages/Settings'
import Trash from './pages/Trash'
import Cloud from './pages/Cloud'
import History from './pages/History'
import ShareGroupDownload from './pages/ShareGroupDownload'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'

export default function App() {
  const navigate = useNavigate()
  const { toast } = useToast()
  
  useEffect(() => {
    console.log('[App] 应用初始化，启动Token管理器')
    
    // 初始化TokenManager（如果有token会自动调度刷新）
    tokenManager.initialize()
    
    // 监听token过期事件
    const handleTokenExpired = () => {
      console.log('[App] Token已过期，跳转到登录页')
      toast({
        title: "登录已过期",
        description: "您的登录会话已失效，请重新登录以继续使用完整功能",
        variant: "destructive",
      })
      navigate('/')
    }
    
    // 监听token刷新成功事件
    const handleTokenRefreshed = (() => {
      console.log('[App] Token已自动刷新，用户可以继续使用')
    }) as EventListener
    
    window.addEventListener('token-expired', handleTokenExpired)
    window.addEventListener('token-refreshed', handleTokenRefreshed as EventListener)
    
    // 清理函数
    return () => {
      window.removeEventListener('token-expired', handleTokenExpired)
      window.removeEventListener('token-refreshed', handleTokenRefreshed as EventListener)
    }
  }, [navigate])
  
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/history" element={<History />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/trash" element={<Trash />} />
        <Route path="/cloud" element={<Cloud />} />
        <Route path="/download/group/:shareKey" element={<ShareGroupDownload />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
      <Toaster />
    </>
  )
}
